export default "__VITE_ASSET__b3bcb582__"